// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.align-center {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.session-timeout-image {
  width: 500px;
  height: 300px;
}

.session-timeout-text {
  font-size: 15px;
  font-weight: 300;
  display: table;
  margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/components/SessionExpired.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,QAAA;EACA,SAAA;EAEA,gCAAA;AACJ;;AAEA;EACI,YAAA;EACA,aAAA;AACJ;;AAEA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AACJ","sourcesContent":[".align-center{\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n}\n\n.session-timeout-image{\n    width: 500px;\n    height: 300px;\n}\n\n.session-timeout-text{\n    font-size: 15px;\n    font-weight: 300;\n    display: table;\n    margin: 0 auto;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
